import { render, staticRenderFns } from "./orderList.vue?vue&type=template&id=c4420b36&scoped=true"
import script from "./orderList.vue?vue&type=script&lang=js"
export * from "./orderList.vue?vue&type=script&lang=js"
import style0 from "./orderList.vue?vue&type=style&index=0&id=c4420b36&prod&scoped=true&lang=less"
import style1 from "@/assets/h5css/shop/orderList.less?vue&type=style&index=1&id=c4420b36&prod&scoped=true&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4420b36",
  null
  
)

export default component.exports